var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333374 7.00001C0.333374 3.33334 3.33337 0.333344 7.00004 0.333344C10.6667 0.333344 13.6667 3.33334 13.6667 7.00001C13.6667 10.6667 10.6667 13.6667 7.00004 13.6667C3.33337 13.6667 0.333374 10.6667 0.333374 7.00001ZM7.00004 3.53334C7.46671 3.53334 7.80004 3.93334 7.80004 4.33334C7.80004 4.73334 7.46671 5.13334 7.00004 5.13334C6.53337 5.13334 6.20004 4.80001 6.20004 4.33334C6.20004 3.86668 6.53337 3.53334 7.00004 3.53334ZM5.00004 10.3333V9.00001H6.33337V7.00001H5.66671V5.66668H7.00004C7.40004 5.66668 7.66671 5.93334 7.66671 6.33334V9.00001H9.00004V10.3333H5.00004Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9b793dbc.svg";
export { ForwardRef as ReactComponent };